export const CommonNouns = `ability,abilities
absence,absences
abuse,
access,accesses
accident,
accommodation,
account,
acid,
act,
actor,
action,
activity,activities
addition,
address,addresses
administration,administrations
adult,
advance,
advantage,
advice,
afternoon,
age,
agency,agencies
agent,
agreement,
agriculture,
aid,
aim,
air,
aircraft,aircraft
alternative,
amount,
analysis,analyses
animal,
answer,
appeal,
appearance,
apple,
application,
appointment,
approach,approaches
approval,
area,areas
argument,
arm,
army,armies
arrival,
art,
article,
artist,
aspect,
assembly,assemblies
assessment,
assistance,assistances
association,
atmosphere,
attack,
attempt,
attention,
attitude,
audience,
author,
authority,authorities
autumn,
average,
award,
awareness,awarenesses
baby,babies
back,
background,
bag,
balance,
ball,
band,
bank,
bar,
base,
basis,bases
bath,
battle,
beach,beaches
beauty,beauties
bed,
bedroom,
behalf,behalves
behaviour,behaviours
belief,
benefit,
bill,
bird,
birth,
bishop,
block,
blood,
board,
boat,
body,bodies
book,
border,
bottle,
bottom,
box,boxes
boy,
brain,
branch,branches
bread,
break,
breakfast,
breath,
bridge,
brother,brothers
brown,
budget,
bus,buses
bush,bushes
business,businesses
cabinet,
call,
campaign,
cancer,
candidate,
capacity,capacities
capital,
captain,
car,
card,
care,
career,
case,
cash,cashes
castle,
cat,
cause,
cell,
centre,centres
century,centuries
chain,
chair,
chairman,chairmen
challenge,
championship,
chance,
chancellor,
change,
channel,
chapter,
character,characters
charge,
charity,charities
chest,
chief,
child,children
china,
choice,
christ,christs
church,churches
city,cities
claim,
class,classes
clause,
client,
club,
co-operation,co-op
coal,
coast,
code,
coffee,
collection,
college,
colour,colours
combination,
command,
commission,
commitment,
committee,
communication,
community,communities
company,companies
comparison,
competition,
computer,
concentration,concentrations
concept,
concern,
conclusion,
condition,
conference,
confidence,
conflict,
congress,congresses
connection,
consequence,
consideration,
constitution,
construction,
consumer,
contact,
content,
context,
contract,
contrast,
contribution,
control,
convention,
conversation,
copy,copies
core,
corner,
corporation,
cost,
council,
country,countries
countryside,
county,counties
couple,
course,
court,
cover,
cow,
credit,credits
crime,
crisis,crises
criticism,
cross,crosses
crowd,
crown,
culture,
cup,
currency,currencies
curriculum,curricula
customer,
dad,
damage,
danger,
date,
daughter,daughters
day,
deal,deals
death,
debate,
debt,
decade,
decision,
decline,
defence,
definition,
degree,
delivery,deliveries
demand,
democracy,democracies
department,
deputy,deputies
description,
design,
desire,desires
desk,
detail,
development,
diet,
difference,
difficulty,difficulties
dinner,
direction,
director,
discipline,
discussion,
disease,
display,displays
distance,
distinction,
distribution,
district,
division,
doctor,
document,
dog,
door,
doubt,
drama,dramas
dream,
dress,dresses
drink,
drive,
driver,
drug,
duty,duties
earth,
east,
economy,economies
edge,
editor,
education,
effect,
efficiency,efficiencies
effort,
election,
electricity,electricities
element,
emergency,emergencies
emphasis,emphases
empire,
employment,
end,
energy,energies
engine,
english,
enterprise,
entry,entries
environment,
equipment,equipments
error,
establishment,
estate,
event,
evidence,evidences
examination,
example,
exchange,
executive,
exercise,
exhibition,
existence,
expansion,
expenditure,expenditures
experience,
expert,
explanation,
expression,
extension,
extent,
eye,eyes
face,
fact,
factory,factories
failure,
faith,
fall,
family,families
farm,
fashion,
father,
favour,
fear,
feature,
field,
fig.,fig.
figure,
file,
film,
finance,
fire,
firm,
fish,fish
flat,
flight,
floor,
flow,
focus,foci
food,foods
foot,feet
football,
force,
forest,
form,
formation,
foundation,
framework,
frank,
freedom,
friend,
front,
fruit,
fuel,
fun,
function,
fund,
furniture,furnitures
future,
gallery,galleries
game,
gap,
garden,
gas,gases
gate,
general,
generation,
gentleman,gentlemen
girl,
glass,glasses
goal,
god,
gold,
golf,
government,
graham,
grant,
grass,grasses
green,
group,
growth,
guide,
gun,
guy,
hair,
half,halves
hall,
hand,
head,
health,healths
heart,
heat,
height,
hell,
help,helps
henry,henries
hill,
history,histories
hole,
holiday,
home,
hope,
horse,
hospital,
hotel,
hour,
house,houses
household,
husband,
ice,
idea,ideas
identity,identities
image,
impact,
importance,
impression,
improvement,
incident,
income,
increase,
independence,
index,indexes
individual,
industry,industries
inflation,
influence,
information,informations
initiative,
injury,injuries
inquiry,inquiries
instance,
institute,
institution,
insurance,insurances
intelligence,
intention,
interest,interests
interpretation,
interview,
introduction,
investigation,
investment,
involvement,involvements
iron,
island,
issue,
item,
jack,
jane,
japan,
job,
joe,
john,
jones,joneses
journey,
judge,
justice,
key,
kind,
king,
kingdom,
kitchen,
knowledge,knowledges
labour,
lack,
lady,ladies
lake,
land,
lane,
language,
law,laws
lead,
leader,
leadership,
league,
lee,lees
leg,
legislation,legislations
length,
letter,
level,
lewis,lewises
liability,liabilities
library,libraries
licence,licences
life,lives
lifespan,
light,
limit,
line,
link,
list,
literature,literatures
loan,
location,
look,
lord,
loss,losses
lot,
love,
lunch,lunches
machine,
magazine,
maintenance,maintenances
major,
majority,majorities
man,men
management,managements
manager,
manchester,
manner,
map,
march,marches
mark,
market,
marriage,
martin,
mary,
mass,masses
master,
match,matches
material,
may,
meal,
measure,
meat,
member,
membership,
memory,memories
message,
metal,
method,
middle,
mike,
milk,
mill,
mind,
minister,
ministry,ministries
minority,minorities
minute,
mirror,
miss,misses
mistake,
model,
moment,
money,moneys
month,
morning,
mother,
motion,
motor,
mountain,
mouth,
move,
movement,
mum,
murder,
museum,museums
music,musics
name,
nation,
nature,
neck,
need,
network,
new,
news,
newspaper,
night,
no,noes
no.,nos.
noise,
north,
northern,
nose,
note,
notice,
notion,
object,
occasion,
offence,offences
offer,
office,
officer,
oil,
operation,
opinion,
opportunity,opportunities
opposition,
option,
order,
organisation,organisations
organization,
other,
outcome,
output,
owner,
oxford,
package,
page,
pain,
pair,pairs
palace,
panel,
paper,
parent,
parish,parishes
park,
parliament,
part,
partner,
partnership,
party,parties
passage,
past,
path,
patient,
pattern,
paul,
pay,
payment,
peace,peaces
pension,
performance,
period,
person,persons
peter,
phase,
philosophy,philosophies
phone,
picture,
piece,
place,
plan,
plane,
plant,
plastic,
plate,
play,
player,
pleasure,
point,
police,
policy,policies
pollution,
pool,
population,
port,
position,
possibility,possibilities
post,
potential,
pound,
power,
pp.,
practice,practices
presence,
present,
president,
press,presses
pressure,
price,
prince,
principle,
priority,priorities
prison,
problem,problems
procedure,
process,processes
product,
production,
professor,
profit,
program,
programme,
progress,progresses
project,
property,properties
proportion,
proposal,
protection,
provision,
pub,
public,publics
publication,
purpose,
quality,qualities
quarter,
queen,
question,
race,
radio,
rail,
railway,
rain,rains
range,
rate,
reaction,
reader,
reality,realities
reason,
recession,
recognition,recognitions
record,
recovery,recoveries
reduction,
ref,
reference,
reform,
regime,
region,
relation,
relationship,
release,
relief,
religion,
report,
representation,
republic,
reputation,
request,
research,researches
resistance,
resolution,
respect,
response,
responsibility,responsibilities
rest,
restaurant,
result,
retirement,
return,
revenue,
review,
revolution,
right,
ring,
rise,
risk,
river,
road,
rock,
role,
roof,roofs
room,
round,
route,
row,
rugby,rugbies
rule,
run,
safety,safeties
sale,
sample,
scale,
scene,
scheme,
school,
science,
scope,
screen,
sea,
search,searches
season,
seat,
second,
secretary,secretaries
section,
sector,
security,securities
selection,
self,selves
sense,
sentence,
sequence,
series,series
service,
session,
set,
settlement,
sex,sexes
shape,
share,
sheet,
ship,
shock,
shop,
shoulder,
show,shows
side,
sight,
sign,
significance,
silence,silences
silver,
simon,
sir,sirs
sister,
site,
situation,
size,
skill,
skin,
sky,skies
sleep,
smile,
smith,
snow,
society,societies
software,
soil,
solution,
son,
song,
sort,
sound,
source,
south,
space,
speaker,
specialist,
species,species
speech,speeches
speed,
spirit,
spokesman,spokesmen
sport,
spot,
spring,
square,
st,
staff,staffs
stage,
standard,
star,
start,
state,
statement,
station,
status,statuses
steel,
step,
stock,
stone,stones
store,
strategy,strategies
street,
strength,
stress,stresses
strike,
structure,
struggle,
student,
study,studies
stuff,stuffs
style,
subject,
success,successes
sugar,
sum,
summer,
sun,
supply,supplies
support,
surface,
surprise,
survey,
system,
table,
talk,
tape,
target,
task,
tax,taxes
taylor,taylors
tea,
teacher,
team,
technique,
technology,technologies
telephone,
television,
temperature,
term,
test,
text,
thatcher,
theatre,
theme,
theory,theories
thing,
threat,
time,
title,
tom,
tone,
tony,tonies
top,
total,
touch,touches
tour,
town,
track,
trade,
tradition,
traffic,
train,
transfer,
transport,
travel,
treatment,
treaty,treaties
tree,trees
trial,
trip,
trouble,
trust,
truth,truths
turn,
tv,tvs
type,
un,
uncle,
unemployment,
union,
unit,
university,universities
us,
use,
user,
valley,
value,
van,
variety,varieties
vehicle,
version,
victim,
victory,victories
video,videos
view,
village,
violence,
vision,
visit,
voice,
volume,
vote,
walk,
wall,
war,
waste,
water,
way,
wealth,wealths
weather,
week,
weekend,
weight,
welfare,welfares
west,
while,
white,
whole,
wife,wives
will,
wind,
window,
wine,
winter,
woman,women
wood,
word,
work,
worker,
world,
writer,
xylophone
xmas
year,
youth,
zebra`;